// Currency + finance helpers

export function formatMAD(amount, lang = "fr") {
  const n = Number(amount) || 0;
  const locale = lang === "ar" ? "ar-MA" : lang === "en" ? "en-US" : "fr-FR";
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n);
}

export function formatEUR(amount, lang = "fr") {
  const n = Number(amount) || 0;
  const locale = lang === "ar" ? "ar-MA" : lang === "en" ? "en-US" : "fr-FR";
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n);
}

// Language-aware secondary currency: € for fr/ar, £ for en
export function secondaryCurrency(lang = "fr") {
  return lang === "en"
    ? { code: "GBP", symbol: "£", key: "mad_to_gbp", fallback: 0.079 }
    : { code: "EUR", symbol: "€", key: "mad_to_eur", fallback: 0.093 };
}

export function convertMad(amountMad, rate = {}, lang = "fr") {
  const cur = secondaryCurrency(lang);
  const r = rate[cur.key] || cur.fallback;
  const n = (Number(amountMad) || 0) * r;
  const locale = lang === "ar" ? "ar-MA" : lang === "en" ? "en-US" : "fr-FR";
  return { text: new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n), symbol: cur.symbol, code: cur.code };
}

// Standard amortization: M = P * r / (1 - (1+r)^-n)
export function monthlyPayment(principal, annualRatePct, years) {
  const P = Number(principal) || 0;
  const n = years * 12;
  const r = (Number(annualRatePct) || 0) / 100 / 12;
  if (P <= 0 || n <= 0) return 0;
  if (r === 0) return P / n;
  return (P * r) / (1 - Math.pow(1 + r, -n));
}

export function totalCredit(principal, annualRatePct, years) {
  const m = monthlyPayment(principal, annualRatePct, years);
  return m * years * 12 - principal;
}
